// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { AbortController } from "./AbortController";
import { HttpError, TimeoutError } from "./Errors";
import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { Arg, getDataDetail, sendMessage } from "./Utils"; // Not exported from 'index', this type is internal.

/** @private */

var LongPollingTransport =
/** @class */
function () {
  function LongPollingTransport(httpClient, accessTokenFactory, logger, logMessageContent) {
    this.httpClient = httpClient;
    this.accessTokenFactory = accessTokenFactory;
    this.logger = logger;
    this.pollAbort = new AbortController();
    this.logMessageContent = logMessageContent;
    this.running = false;
    this.onreceive = null;
    this.onclose = null;
  }

  Object.defineProperty(LongPollingTransport.prototype, "pollAborted", {
    // This is an internal type, not exported from 'index' so this is really just internal.
    get: function get() {
      return this.pollAbort.aborted;
    },
    enumerable: true,
    configurable: true
  });

  LongPollingTransport.prototype.connect = function (url, transferFormat) {
    return __awaiter(this, void 0, void 0, function () {
      var pollOptions, token, pollUrl, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            Arg.isRequired(url, "url");
            Arg.isRequired(transferFormat, "transferFormat");
            Arg.isIn(transferFormat, TransferFormat, "transferFormat");
            this.url = url;
            this.logger.log(LogLevel.Trace, "(LongPolling transport) Connecting."); // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)

            if (transferFormat === TransferFormat.Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string") {
              throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
            }

            pollOptions = {
              abortSignal: this.pollAbort.signal,
              headers: {},
              timeout: 100000
            };

            if (transferFormat === TransferFormat.Binary) {
              pollOptions.responseType = "arraybuffer";
            }

            return [4
            /*yield*/
            , this.getAccessToken()];

          case 1:
            token = _a.sent();
            this.updateHeaderToken(pollOptions, token);
            pollUrl = url + "&_=" + Date.now();
            this.logger.log(LogLevel.Trace, "(LongPolling transport) polling: " + pollUrl + ".");
            return [4
            /*yield*/
            , this.httpClient.get(pollUrl, pollOptions)];

          case 2:
            response = _a.sent();

            if (response.statusCode !== 200) {
              this.logger.log(LogLevel.Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + "."); // Mark running as false so that the poll immediately ends and runs the close logic

              this.closeError = new HttpError(response.statusText || "", response.statusCode);
              this.running = false;
            } else {
              this.running = true;
            }

            this.receiving = this.poll(this.url, pollOptions);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  LongPollingTransport.prototype.getAccessToken = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.accessTokenFactory) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.accessTokenFactory()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];

          case 2:
            return [2
            /*return*/
            , null];
        }
      });
    });
  };

  LongPollingTransport.prototype.updateHeaderToken = function (request, token) {
    if (!request.headers) {
      request.headers = {};
    }

    if (token) {
      // tslint:disable-next-line:no-string-literal
      request.headers["Authorization"] = "Bearer " + token;
      return;
    } // tslint:disable-next-line:no-string-literal


    if (request.headers["Authorization"]) {
      // tslint:disable-next-line:no-string-literal
      delete request.headers["Authorization"];
    }
  };

  LongPollingTransport.prototype.poll = function (url, pollOptions) {
    return __awaiter(this, void 0, void 0, function () {
      var token, pollUrl, response, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 8, 9]);

            _a.label = 1;

          case 1:
            if (!this.running) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this.getAccessToken()];

          case 2:
            token = _a.sent();
            this.updateHeaderToken(pollOptions, token);
            _a.label = 3;

          case 3:
            _a.trys.push([3, 5,, 6]);

            pollUrl = url + "&_=" + Date.now();
            this.logger.log(LogLevel.Trace, "(LongPolling transport) polling: " + pollUrl + ".");
            return [4
            /*yield*/
            , this.httpClient.get(pollUrl, pollOptions)];

          case 4:
            response = _a.sent();

            if (response.statusCode === 204) {
              this.logger.log(LogLevel.Information, "(LongPolling transport) Poll terminated by server.");
              this.running = false;
            } else if (response.statusCode !== 200) {
              this.logger.log(LogLevel.Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + "."); // Unexpected status code

              this.closeError = new HttpError(response.statusText || "", response.statusCode);
              this.running = false;
            } else {
              // Process the response
              if (response.content) {
                this.logger.log(LogLevel.Trace, "(LongPolling transport) data received. " + getDataDetail(response.content, this.logMessageContent) + ".");

                if (this.onreceive) {
                  this.onreceive(response.content);
                }
              } else {
                // This is another way timeout manifest.
                this.logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
              }
            }

            return [3
            /*break*/
            , 6];

          case 5:
            e_1 = _a.sent();

            if (!this.running) {
              // Log but disregard errors that occur after stopping
              this.logger.log(LogLevel.Trace, "(LongPolling transport) Poll errored after shutdown: " + e_1.message);
            } else {
              if (e_1 instanceof TimeoutError) {
                // Ignore timeouts and reissue the poll.
                this.logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
              } else {
                // Close the connection with the error as the result.
                this.closeError = e_1;
                this.running = false;
              }
            }

            return [3
            /*break*/
            , 6];

          case 6:
            return [3
            /*break*/
            , 1];

          case 7:
            return [3
            /*break*/
            , 9];

          case 8:
            this.logger.log(LogLevel.Trace, "(LongPolling transport) Polling complete."); // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.

            if (!this.pollAborted) {
              this.raiseOnClose();
            }

            return [7
            /*endfinally*/
            ];

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  LongPollingTransport.prototype.send = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!this.running) {
          return [2
          /*return*/
          , Promise.reject(new Error("Cannot send until the transport is connected"))];
        }

        return [2
        /*return*/
        , sendMessage(this.logger, "LongPolling", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent)];
      });
    });
  };

  LongPollingTransport.prototype.stop = function () {
    return __awaiter(this, void 0, void 0, function () {
      var deleteOptions, token;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logger.log(LogLevel.Trace, "(LongPolling transport) Stopping polling."); // Tell receiving loop to stop, abort any current request, and then wait for it to finish

            this.running = false;
            this.pollAbort.abort();
            _a.label = 1;

          case 1:
            _a.trys.push([1,, 5, 6]);

            return [4
            /*yield*/
            , this.receiving];

          case 2:
            _a.sent(); // Send DELETE to clean up long polling on the server


            this.logger.log(LogLevel.Trace, "(LongPolling transport) sending DELETE request to " + this.url + ".");
            deleteOptions = {
              headers: {}
            };
            return [4
            /*yield*/
            , this.getAccessToken()];

          case 3:
            token = _a.sent();
            this.updateHeaderToken(deleteOptions, token);
            return [4
            /*yield*/
            , this.httpClient.delete(this.url, deleteOptions)];

          case 4:
            _a.sent();

            this.logger.log(LogLevel.Trace, "(LongPolling transport) DELETE request sent.");
            return [3
            /*break*/
            , 6];

          case 5:
            this.logger.log(LogLevel.Trace, "(LongPolling transport) Stop finished."); // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent

            this.raiseOnClose();
            return [7
            /*endfinally*/
            ];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  LongPollingTransport.prototype.raiseOnClose = function () {
    if (this.onclose) {
      var logMessage = "(LongPolling transport) Firing onclose event.";

      if (this.closeError) {
        logMessage += " Error: " + this.closeError;
      }

      this.logger.log(LogLevel.Trace, logMessage);
      this.onclose(this.closeError);
    }
  };

  return LongPollingTransport;
}();

export { LongPollingTransport };